<template>
  <div class="dropdown" v-click-away="hideDropdown" :class="[ extraCssClass ]" v-cloak>
    <button
      type="button"
      class="dropdown__link dropdown__link--checkbox link--no-hover position-relative"
      @click="toggleDropdown()"
      :class="[show ? 'dropdown__link--checkbox-show' : '', inputSelectAll ? 'dropdown__link--all-selected' : '']"
      ref="dropdownLink"
    >
      <ul v-if="checkedOptions.length > 0 && !inputSelectAll" class="dropdown__tags dropdown__tags--suburb">
        <li v-for="(option, index) in checkedOptions" v-show="index < 2" class="mb-0">{{option}}
          <a href="#" @click.prevent="removeSelectedOption(index)"><i class="icon icon--cross"></i></a>
        </li>
        <li v-if="checkedOptions.length > 2" class="mb-0 pr-2">+{{ checkedOptions.length - 2 }}</li>
      </ul>
      <span class="dropdown__selected" :class="{'dropdown__selected--district': options.length === 0 || inputSelectAll}" v-if="checkedOptions.length === 0 || inputSelectAll">
        {{ emptyString }}
      </span>
      <i class="icon" :class="[ show ? 'icon--flipped' : '', iconClass ]"></i>
    </button>
    <transition name="fade">
      <div
        class="dropdown__holder dropdown__holder--suburb"
        v-if="show"
        v-cloak
        id="dropdownHolder"
        :class="[wrapperClass]"
      >
        <a href="#" class="dropdown__suburb-close" @click.prevent="close"><i class="icon icon--cross"></i></a>
        <a href="#" class="dropdown__suburb-next" @click.prevent="close">Next</a>
        <ul class="dropdown__list-suburb">
          <li class="dropdown__list-suburb-item mr-0">
            <div class="checkbox-custom" v-if="options.length > 0">
              <input type="checkbox" class="subscribe" id="selectAll" name="option-checkbox" value="1" v-model="inputSelectAll" @click="selectAllClick">
              <label class="form-check-label mb-0" for="selectAll">All Suburbs</label>
            </div>
          </li>
          <li v-for="option in options" class="dropdown__list-suburb-item mr-0" :class="{ 'dropdown__list-item--active': options.length === 0 }">
            <div class="checkbox-custom">
              <input type="checkbox" class="subscribe" :id="option.key" name="option-checkbox" :value="option.value" v-model="checkedOptions">
              <label class="form-check-label mb-0" :for="option.key">{{ option.value }}</label>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
/**
 * Simple Dropdown with multiple checkbox component.
 *
 * Usage:
 * ```html
 *  <suburb-dropdown
 *     :options="'[{ key: "key1", value: "value1" }, { key: "key2", value: "value2" }, ....]'"
 *     @selected="searchBySection"
 *  ></suburb-dropdown>
 * ```
 *
 */
import {ref, onMounted, computed, defineProps, onBeforeMount, watch} from 'vue'
import axios from 'axios'
import useFilterStore from '../../store/filterStore'

const props = defineProps({
  emptyString: {
    default: 'Select an option',
  },
  districtId: {
    default: 0,
  },
  defaultCheckedOptions: {
    type: Array,
    default: () => [],
  },
  iconClass: {
    default: 'icon--down',
  },
  extraCssClass: {
    type: String,
  },
  defaultType: {
    default: 'careHome',
  },
});

// Data properties
const filterStore = useFilterStore()
const show = ref(false);
const checkedOptions = ref(props.defaultCheckedOptions);
const inputSelectAll = ref(true);
const clickTag = ref(false);
const options = ref([]);
const dropdownLink = ref(null);

// Computed properties
const wrapperClass = computed(() => {
  if (options.value.length > 32) {
    return 'dropdown__holder--suburb-full';
  } else if(options.value.length > 21) {
    return 'dropdown__holder--suburb-4-3';
  } else if(options.value.length > 10) {
    return 'dropdown__holder--suburb-4-2';
  }

  return 'dropdown__holder--suburb-4-1';
});

// Methods
const selectAllClick = () => {
  checkedOptions.value = [];
};

const toggleDropdown = () => {
  if (!clickTag.value && options.value.length > 0) {
    show.value = !show.value;

    if (show.value) {
      const height = parseInt(dropdownLink.value.clientHeight, 10) + 1;
      //document.getElementById('dropdownHolder').style.top = `${height}px`;
    }
  } else {
    clickTag.value = false;
  }
};

const hideDropdown = () => {
  if (show.value) {
    show.value = false;
  }
};

const removeSelectedOption = (index) => {
  if (index > -1) {
    checkedOptions.value.splice(index, 1);
  }
  clickTag.value = true;
};

const close = () => {
  show.value = false;
};

const getSuburbFilterUrl = (districtId) => {
  return `/api/suburbs?districtId=${districtId}&type=${props.defaultType}`;
};

watch(
  () => filterStore.district,
  async (newDistrict) => {

    if (newDistrict.id) {
      await axios.get(getSuburbFilterUrl(newDistrict.id)).then((response) => {
        options.value = response.data;

        inputSelectAll.value = checkedOptions.value.length === 0
      });
    } else {
      inputSelectAll.value = true;
      checkedOptions.value = [];
      options.value = [];
    }
  }
);

watch(
  () => checkedOptions.value,
  (newOptions) => {
    filterStore.suburbs = newOptions;

    if (newOptions.length > 0) {
      inputSelectAll.value = false;
    }
  }
);

onMounted(() => {
  if (checkedOptions.value.length > 0) {
    inputSelectAll.value = false;
  }

  filterStore.suburbs = checkedOptions.value;
});

onBeforeMount(() => {
  if (props.districtId) {
    axios.get(getSuburbFilterUrl(props.districtId)).then((response) => {
      options.value = response.data;
    });
  }
});
</script>
